import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const EvaluationClass = (store) => ({
  path: ROUTE.CLASS_FEEDBACK,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'classFeedback',
    loadReducer: () => import('./ClassFeedbackState'),
    loadComponent: () => import('./ClassFeedbackContainer'),
  })
})

export default EvaluationClass
